/* eslint-disable */
export default {
  schedule: 'Programmer une réunion',
  prompt:
    'Veuillez autoriser RingCentral à accéder à vos informations de compte Google.',
  saveAsDefault: 'Enregistrer par défaut',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
